import React from 'react';
import { useSelector } from 'react-redux';
import { isDone } from '../../constants/loading_state';
import { PrismicPage } from '../../prismic';
import { getPrismicLoadingState, getPrismicPage } from '../../redux/pages';

export const PrismicSingle = (props: { render: (page: PrismicPage) => JSX.Element }) => {
  const loadingState = useSelector(getPrismicLoadingState);
  const page = useSelector(getPrismicPage);

  if (!isDone(loadingState)) {
    return null;
  }

  return <>{props.render(page)}</>;
};
